import request from "root/js/request";

/* export const getOptimizatioTariffTable = async ({
  wb_api_key_ids,
  sales_history_period,
  order_by,
}) => {
  const response = await request({
    url: "/analytics/forecasting/tariffs_and_wh_times_table/",
    method: "get",
    params: {
      wb_api_key_ids,
      sales_history_period,
      order_by,
    },
  });
  return response.data;
}; */

// верхнее апи использовалось раньше

export const getSupplyDistributionLogisticTable = async ({
  wb_api_key_ids,
  sales_share_history_period,
  order_by,
  tariff_date,
  exclude_region_clusters,
}) => {
  const response = await request({
    url: "/analytics/forecasting/warehouse_supply_distribution_logistic_cost/",
    method: "post",
    params: {
      wb_api_key_ids,
      sales_share_history_period,
      order_by,
      tariff_date,
      exclude_region_clusters,
    },
  });
  return response.data;
};
